export default __webpack_public_path__ + "static/media/arrowDownDark.6f15e0dd.svg";